<template>

  <div>
    <template>
      <div id="breadcrumb-alignment" class="mb-1">
        <div class="d-flex justify-content-start breadcrumb-wrapper">
          <b-breadcrumb :items="breadCrumb()" />
        </div>
      </div>
    </template>

    <!-- Table Container Card -->

    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col cols="12" md="3" class="mb-md-1.5 mb-2 mobile_tab_max_width_flex mobile_tab_margin_bottom_point_five">
            <b-form-select v-model="selectedArea">
              <b-form-select-option value="" disabled>Select Area</b-form-select-option>
              <b-form-select-option :value="'all'" v-if="areas && areas.length > 1">All Areas</b-form-select-option>
              <b-form-select-option :value="area._id" v-for="area in areas" :key="area._id">
                {{ area.name | capitalize }}</b-form-select-option>
            </b-form-select>
          </b-col>

          <b-col cols="12" md="3" class="mb-md-1.5 mb-2 mobile_tab_max_width_flex mobile_tab_margin_bottom_point_five">
            <b-form-select v-model="selectedSupplier">
              <b-form-select-option value="">Select Supplier</b-form-select-option>
              <b-form-select-option :value="supplier._id" v-for="supplier in suppliers" :key="supplier._id">
                {{ supplier.name | capitalize }}</b-form-select-option>
            </b-form-select>
          </b-col>

          <b-col cols="12" md="3" class="mb-md-1.5 mb-2 mobile_tab_max_width_flex mobile_tab_margin_bottom_point_five">
            <b-form-select v-model="selectedMonth">
              <b-form-select-option value="" disabled>Select Month</b-form-select-option>
              <b-form-select-option :value="month" v-for="month in months" :key="month">
                {{ month | capitalize }}</b-form-select-option>
            </b-form-select>
          </b-col>

          <b-col cols="12" md="3" class="mb-md-1.5 mb-2 mobile_tab_max_width_flex mobile_tab_margin_bottom_point_five">
            <b-form-select v-model="selectedYear">
              <b-form-select-option :value="null" disabled> Select Year</b-form-select-option>
              <b-form-select-option v-for="year in years" :key="year" :value="year">
                {{ year }}
              </b-form-select-option>
          </b-form-select>
          </b-col>

          <b-col cols="12" md="3" class="mb-md-0 mb-2 mobile_tab_max_width_flex mobile_tab_margin_bottom_point_five">
            <b-form-select v-model="selectedDeliverySite">
              <b-form-select-option value="" >Select Deliver-To Location</b-form-select-option>
              <b-form-select-option :value="deliverySite.site_name" v-for="deliverySite in deliverySites" :key="deliverySite.site_name">
                {{ deliverySite.site_name | capitalize }}</b-form-select-option>
            </b-form-select>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card no-body class="mb-0" v-if="areas != null">
      <MoqReportComponent :deliverySites="deliverySites" :selectedArea="selectedArea" :selectedSupplier="selectedSupplier"
        :selectedMonth="selectedMonth" :selectedYear="selectedYear" :selectedDeliverySite="selectedDeliverySite" v-if="!loading" />
    </b-card>

  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BAlert, BFormGroup, BTabs, BTab,
  BBadge, BDropdown, BDropdownItem, BPagination, BFormCheckbox, BCardBody, BFormSelectOption, BFormSelect, VBTooltip, BFormTextarea, BForm, BFormDatepicker, BBreadcrumb, BFormRadio
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { GET_API, POST_API } from "../../../store/actions.type"
import Datepicker from 'vuejs-datepicker';
import moment from "moment-timezone";
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import MoqReportComponent from './MoqReportComponent.vue'

export default {
  components: {
    Datepicker,
    BCardBody,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,
    vSelect,
    BFormSelect,
    BFormSelectOption,
    VueApexCharts,
    BFormTextarea,
    BAlert,
    BFormGroup,
    BForm,
    BFormDatepicker,
    BBreadcrumb,
    BFormRadio,
    MoqReportComponent,
    BTabs, BTab,
  },
  directives: {
    'b-tooltip': VBTooltip,

  },
  watch: {
    selectedArea: function (newVal, oldVal) {
      console.log("selectedArea:", newVal);
      this.getAllMoq();
      // this.getMoq();
    },
    selectedMonth: function (newVal, oldVal) {
      this.getAllMoq();
      // this.getMoq();
    },
    selectedYear: function (newVal, oldVal) {
      // this.getMoq();
    }
  },
  data() {
    return {
      role: this.$store.getters.currentUser.role,
      user_id: this.$store.getters.currentUser._id,
      site: this.$store.getters.currentUser.om_sites[0] ? this.$store.getters.currentUser.om_sites[0] : '',
      deliverySites: '',
      organization: this.$store.getters.currentUser.organization || '',
      areas: null,
      selectedArea: '',
      selectedSupplier: '',
      moq_records: '',
      suppliers: [],
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      selectedYear: null,
      years: [],
      selectedDeliverySite: '',
      selectedMonth: moment().add(1, 'months').format('MMMM'),
      loading: true,
      error_message: '',
    }
  },
  methods: {
    showAlert() {
      Swal.fire({
        position: 'center',
        icon: 'error',
        text: this.error_message,
        showConfirmButton: false,
        timer: 3000
      })
    },
    getAllMoq() {
      this.suppliers = [];
      return this.$store.dispatch(POST_API, {
        data: {
          user_id: this.user_id,
          area: this.selectedArea,
          month: this.selectedMonth,
          year: this.selectedYear
        },
        api: '/api/inventory-moq-report'
      }).then(() => {
        if (this.$store.getters.containsErrors) {
          this.error_message = this.$store.getters.getErrors;
          this.showAlert();
        } else {
          this.moq_records = this.$store.getters.getResults.data.moq_report;
          this.moq_records.forEach((data) => {
            const supplier = data.supplier;
            // Check if supplier already exists in the array
            if (!this.suppliers.some(existingSupplier => existingSupplier._id === supplier._id)) {
              this.suppliers.push(supplier);
            }
          });
          // Always the deliver-to sites the in-scope orders actually use. It
          // used to be overridden with the user's own project sites, which hid
          // every cross-area / unassigned deliver-to location from the filter.
          this.deliverySites = this.$store.getters.getResults.data.sites;
          this.loading = false;
        }
      })
    },
    getMoqYears() {
      return this.$store.dispatch(GET_API, {
        data: {

        },
        api: '/api/moqs/years'
      }).then(() => {
        if(this.$store.getters.containsErrors) {
          this.error_message = this.$store.getters.getErrors;
        } else {
          var data = this.$store.getters.getResults.data;
          this.years = data;
          this.selectedYear = data[data.length-1];
        }
      });
    },
    findArea() {
      return this.$store.dispatch(POST_API, {
        data: {
          user_id: this.user_id,
          site: this.site,
          om_sites: this.$store.getters.currentUser.om_sites,
          role: this.role,
          organization: this.organization,
        },
        api: '/api/inventory-find-area'
      }).then(() => {
        if (this.$store.getters.containsErrors) {
          this.error_message = this.$store.getters.getErrors;
          this.showAlert();
        } else {
          this.areas = this.$store.getters.getResults.data;
          if(this.areas.length > 1){
            this.selectedArea = 'all';
          } else {
            this.selectedArea = this.areas[0]._id;
          }
        }
      })
    },
    breadCrumb() {
      var item = [{
        to: { name: 'client-dashboard' },
        text: 'Dashboard',
      }, {
        to: null,
        text: 'Inventory'
      }, {
        to: null,
        text: 'Reports'
      }, {
        to: null,
        text: 'MOQ Report',
        active: true
      }];;
      return item;
    },
  },
  mounted() {
    this.findArea();
    this.getMoqYears();
  }

}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>